import type { Material, Mesh } from 'three';

export function disposeObject(object: Mesh | null) {
    if (!object) {
        return;
    }

    object.geometry?.dispose();

    const materials = object.material;
    if (Array.isArray(materials)) {
        materials.forEach((material: Material | null | undefined) => material?.dispose?.());
    } else {
        materials?.dispose?.();
    }
}

export function isInputElement(element: EventTarget | null): boolean {
    return (
        element instanceof HTMLInputElement ||
        element instanceof HTMLTextAreaElement ||
        (element instanceof HTMLElement && element.isContentEditable)
    );
}
